/**
 * Created by Simon Zhao on 12/08/2022
 * Description:
 * Defines the view model of project history items.
 * ------ maintenance history ------
 */
import { KeyValue } from '@angular/common';
import { FieldDefinition, ProjectHistoryItem } from '../../../tamalelibs/models/workflow.model';

export class ProjectHistoryFieldDetail {
    fieldDefinition: FieldDefinition;
    value: any;
}

export class ProjectHistoryItemViewModel {
    record: ProjectHistoryItem;
    fieldsArray: Array<KeyValue<string, ProjectHistoryFieldDetail>> = [];
}
